<template>
  <span class="im-right-content-height-more" @click="showChatInfo">
    <i class="el-icon-more"></i>
  </span>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ImRightContentHeaderMore',
  computed: {
    ...mapState({
      imShowChatInfoVisible: state => state.imShowChatInfoVisible,
    })
  },
  data () {
    return {
    }
  },
  methods: {
    showChatInfo () {
      this.$store.dispatch('changeImShowChatInfoVisibleAction', !this.imShowChatInfoVisible)
    }
  }
}
</script>

<style lang="stylus" scoped>
.im-right-content-height-more {
  cursor: pointer;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/common/im/right/ImRightContentHeaderMore.vue